module.exports = __webpack_public_path__ + "static/img/result2.7dfc0fdd.png";